import { scrollToTarget } from './lib/helpers/css-utils'
import './lib/jquery'

export default function scrollToAnchorTarget(wizard) {
  // Anchors
  const targets = window.location.hash
  if (targets) {
    const anchors = targets.split('_')
    const targetStep = $(anchors[0])
    wizard.goToStep(targetStep, null)
    if (anchors.length > 1) {
      const scrollTarget = `#${anchors[1]}`
      scrollToTarget(scrollTarget)
    }
  }
}
